import React from "react";

export default function About ()
{
    return (
        <h1>Inside About.js</h1>

    );
}